import logo from "@/public/images/logo.png";
import dark_logo from "@/public/images/logo_dark.png";
import jobOpportinuty from "@/public/images/job-opportinuty.png";
import forgetPassword from "@/public/images/forget-password.png";
import signIn from "@/public/images/Sign-in.png";
import signUp from "@/public/images/signUp.png";
import service from "@/public/images/service.jpg";
import profile from "@/public/images/profile.jpg";
import messages from "@/public/images/messages.png";
import applications from "@/public/images/applications.png";
import exams from "@/public/images/exams.png";
import anonymous from "@/public/images/anonymous.png";
import noResult from "@/public/images/no-result.svg";
import resetPassword from "@/public/images/reset-password.svg";
import favicon from "@/public/images/favicon.png";
import serverError from "@/public/images/server-error.png";
import Verify from "@/public/images/Verifie.png";
import service1 from "@/public/images/service1.png";
import service2 from "@/public/images/service2.png";
import service3 from "@/public/images/service3.png";
import service4 from "@/public/images/service4.png";
import jobs from "@/public/images/latest jobs.png";

export const images = {
  logo,
  dark_logo,
  jobOpportinuty,
  signIn,
  forgetPassword,
  signUp,
  service,
  profile,
  messages,
  applications,
  exams,
  anonymous,
  noResult,
  resetPassword,
  favicon,
  serverError,
  Verify,
  service1,
  service2,
  service3,
  service4,
  jobs,
};
